import React, {FC} from 'react';

import {addQueryToPath} from '../../../../../libs/shared/core/src/helpers/browser/urlHelpers';
import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {TeammateModel} from '../../../../../libs/shared/core/src/models/api/teammateModel';
import {Banner, BannerTypesEnum} from '../../../../../libs/shared/ui/src/components/banners/banner';
import {BannerAction} from '../../../../../libs/shared/ui/src/components/banners/bannerAction';
import {BannerContent} from '../../../../../libs/shared/ui/src/components/banners/bannerContent';
import {BannerContentTitle} from '../../../../../libs/shared/ui/src/components/banners/bannerContentTitle';
import {BannerFooterActions} from '../../../../../libs/shared/ui/src/components/banners/bannerFooterActions';
import {BannerIcon} from '../../../../../libs/shared/ui/src/components/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../../../libs/shared/ui/src/components/banners/bannersContext';
import {useLinkNavigation} from '../../../../../libs/shared/ui/src/components/navigation/useLinkNavigation';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface AbuserFlagBannerProps {
  isAdmin: boolean;
  isFlagged: boolean;
  otherAdmins: ReadonlyArray<TeammateModel>;
}

/*
 * Component.
 */

export const AbuserFlagBanner: FC<AbuserFlagBannerProps> = ({isAdmin, isFlagged, otherAdmins}) => {
  const theme = useUserTheme();
  const {navigateToLink} = useLinkNavigation();

  const onContactUsClick = () => {
    const emails = otherAdmins.map((a) => a.email);

    navigateToLink(
      addQueryToPath('mailto:support@front.com', {
        subject: 'Flagged Account',
        cc: emails.length > 0 ? emails.join(',') : undefined,
      }),
    );
  };

  if (!isFlagged || !isAdmin) {
    return null;
  }

  return (
    <Banner
      bannerType={BannerTypesEnum.MULTILINE}
      color={theme.palette.red.shade40}
      priority={BannerPrioritiesEnum.ERROR}
    >
      <BannerIcon iconName="warningFilledSmall" />
      <BannerContent>
        <BannerContentTitle>
          <Trans id="banner-abuseflag-title">Flagged account</Trans>
        </BannerContentTitle>
        <Trans id="banner-abuseflag-description">
          Your Front instance has been flagged for unusual activity. You will not be able to create new
          channels. Please contact us at support@front.com to unblock your account.
        </Trans>
      </BannerContent>
      <BannerFooterActions>
        <BannerAction onClick={onContactUsClick}>
          <Trans id="banner-abuseflag-action">Contact us</Trans>
        </BannerAction>
      </BannerFooterActions>
    </Banner>
  );
};
